import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { scrollToTop } from '../utils/functions';

export const useStepper = () => {
  const navigate = useNavigate();
  const { step } = useParams();

  const initialStep = parseFloat(step) || 0;

  const [stepper, setStepper] = useState(initialStep);

  useEffect(() => {
    const urlStep = Math.floor(stepper);
    navigate(`/stepper/${urlStep}`);
  }, [stepper, navigate]);

  const avanzar = () => {
    setStepper(prev => Math.floor(prev) + 1);
  };

  const retroceder = (target = null) => {
    if (target !== null) {
      setStepper(parseFloat(target));
    } else {
      setStepper(prev => (Math.floor(prev) > 0 ? Math.floor(prev) - 1 : 0));
    }
  };

  const goToStep = (targetStep) => {
    scrollToTop();
    setStepper(parseFloat(targetStep));
  };

  return {
    stepper,
    avanzar,
    retroceder,
    goToStep,
    setStep: setStepper,
  };
};
